import { getLink } from "../../../utils/utils";

import author from "./author";

const content = {
	esp: (
		`
		<p class="mb-2">
			Interesan sorton havas tiu ĉi libro… 
			Ĵus pasis ĝuste du jaroj de ĝia ekzistado – kaj <u>neniu</u> el esperantistoj reeĥis al ĝi. 
		</p>
		
		<p class="mb-2">
			Ŝajnis, ke jam fin-fine aperis tio, kion ĉiuj delonge atendis, je kio esperis kaj al kio strebis: 
			verki libron pri belaj tagoj de nia aktiva vivo, kiam ni <u>reale</u> vivis per la ideo de Esperanto kaj en medio de Esperanto, 
			kiam ni kreis tiun medion kaj vere pliriĉigis la kulturon de Esperanto per kantoj kaj verkoj, naskitaj sub influo de vera vivo, 
			sed ne ĉe skribotablo de ermito. 
			Tio estis kurta kaj feliĉa periodo, kiam la lando Esperantujo vere ekzistis sur la Tero.
		</p>
		
		<p class="mb-2">
			Kaj multaj lastatempe interŝanĝis pigrajn kaj malviglajn pensojn, ke estus bone verki… aŭ ke iu ekverku… 
			Sed neniu ekis.
		</p>
		
		<p class="mb-2">
			Sed jen iu, sen interkonsiliĝi kun la samideanaro, ekis kaj verkis. Kial do neniu ĝojas, ke efektiviĝis la revo, ke jam aperis la libro?
		</p>
		
		<p class="mb-2">
			Respondoj multas. 
			Eble, aperas domaĝo: nu kial do, ja ĉe mi jam delonge estis deziro, persistis deziro… sed vi komprenas ja: ĉiutageco, zorgoj… ja ajna reala afero pli gravas, ol tiuj infanecaj esperoj kaj revoj. 
		</p>
		
		<p class="mb-2">
			Sed iu simple indignas, ke oni antaùis lin: fakte, li ne intencis reale fari ion… sed revoj vagadis, logis… kaj jen iu sensignifa provinca ulo arogis! 
		</p>
		
		<p class="mb-2">
			Kaj iu rekte konfesas: “Al mi neinterese estas legi, kion skribas nekonataj homoj; se estus la libro pri niaj korifeoj!..” 
		</p>
		
		<p class="mb-2">
			Sed la korifeoj, al kiuj estis proponite kunlabori, rifuzis sub diversaj pretekstoj; sed mi timas, ke la kialo estis nur unu: ne faligi sian prestiĝon partoprenante en iu marĝenula almanako kun neĉefurbaj aŭtoroj. 
		</p>

		<p class="mb-2">
			Kaj al simplaj nuntempaj esperantistoj vere ne estas interese legi pri fremda interesa vivo; ja sian propran interesan vivon ili ne havis! 
			Kaj apenaŭ tiuj memadoraj aŭtoroj vere travivis tion, kion ili priskribas: ja tio ne povas esti, ja la vivo estas griza kaj enua, kaj ili simple rakontas fabelojn, fi al ili! 
		</p>
		`
	),
	ru: (
		`
		<p class="mb-2">
			Вот интересная судьба у этой книжки. Сегодня ровно два года, как она существует, – и <u>никто</u> из эсперантистов не откликнулся на неё. 
		</p>
		
		<p class="mb-2">
			А ведь, казалось, это то, чего так долго ждали, на что надеялись и к чему стремились: создать книгу о прекрасных днях нашей активной жизни, 
			когда мы <u>в самом деле</u> жили идеей эсперанто и в среде эсперанто, когда мы создавали эту среду и по-настоящему обогащали культуру эсперанто: 
			песнями, стихами, которые рождались под влиянием самой жизни, а не за письменным столом отшельника. 
			Это был краткий и счастливый период, когда страна Эсперантида в самом деле существовала на Земле.
		</p>
		
		<p class="mb-2">
			И многие сейчас обменивались вялыми и ленивыми мыслями, что хорошо бы … написать бы … или чтоб кто-нибудь написал… 
			Но никто не брался и не писал. 
		</p>
		
		<p class="mb-2">
			Но вот кто-то, не посоветовавшись ни с кем, взялся и написал. Почему же никто не радуется, что сбылась мечта, что есть уже такая книга? 
		</p>
		
		<p class="mb-2">
			Ответов много. 
			Возможно, досада: да как же это, вот у меня было желание, уже много лет было, да вы ж понимаете, дела, заботы… и любое дело важнее, чем те детские надежды и мечты. 
		</p>

		<p class="mb-2">
			А кто-то просто возмущён, что его опередили: он, в общем-то, и не собирался, – но бродили мечты, и вдруг какой-то незначительный человек из провинции посмел… 
		</p>

		<p class="mb-2">
			А кто-то прямо так и говорит: Мне неинтересно читать, что пишут неизвестные люди; вот если бы книга была про наших корифеев… 
		</p>

		<p class="mb-2">
			А корифеи, которым было предложено сотрудничество, отказывались под разными предлогами, но боюсь, что идея была одна: не уронить своё реноме, опять-таки, в маргинальном сборнике с нестоличными авторами. 
		</p>

		<p class="mb-2">
			А простым современным эсперантистам и в самом деле неинтересно читать про чужую интересную жизнь… своей-то такой не было! 
			И вряд ли у них, тех, кто пишет в этой книжке, было: всё это сказки… 
		</p>
		`
	)
}



const itemBookInfo = {
	esp: {
		bookName: `
			La plej belaj tagoj de nia vivo.
			Pri lingvo esperanto, sed ne nur
		`,
		content: `
			<p>
				La eldono dua, <br/>
				korektita kaj ampleksigita <br/>
				Ideo, kompilo, tekstoj: <br/>
				T. V. Auderskaja <br/> <br/>
				Kovrilo: <br/>
				A. N. Belenko <br/> <br/>
				Redaktoroj: <br/>
				N. L. Gudskov, V. S. Aroloviĉ <br/> <br/>
				Ĝenerala dezajno kaj enpaĝigo: <br/>
				N. L. Gudskov <br/> <br/>
				REU, Odeso-Moskvo, 2020, 244 p.
			</p>
		`
	},
	ru: {
		bookName: `
			Лучшие дни нашей жизни.
			О языке эсперанто и не только
		`,
		content: `
			<p>
				Издание второе, <br/>
				исправленное и дополненное. <br/>
				Идея, составление, тексты: <br/>
				Т. В. Аудерская. <br/> <br/>
				Обложка: <br/>
				А. Н. Беленко. <br/> <br/>
				Редактура текста: <br/>
				Н. Л. Гудсков, В. С. Аролович. <br/> <br/>
				Общее оформление и вёрстка: <br/>
				Н. Л. Гудсков. <br/> <br/>
				РоСЭ, Одесса — Москва, 2020, 244 с.
			</p>
		`
	}
}


const itemName = {
	esp: 'Provo de memrecenzo',
	ru: 'Как рецензия на зелёную книжку'
}

const item = {
	itemlink: getLink(itemName.esp),
	esp: {
		itemName: itemName.esp,
		itemContent: content.esp,
		itemBookInfo: itemBookInfo.esp,
		itemAuthor: author.esp,
	},
	ru: {
		itemName: itemName.ru,
		itemContent: content.ru,
		itemBookInfo: itemBookInfo.ru,
		itemAuthor: author.ru
	}
}

export default item;